// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"507339ce","690":"2fafc5bd","742":"3e081ea0"}[chunkId] + ".chunk.js";
};